/* eslint @typescript-eslint/no-explicit-any: 0 */
import i18n from 'i18next'

export function createTranslationLink(key: string, defaultParams: Record<string, any> = {}) {
	return (params: Record<string, any> = {}) =>
		i18n.t(key, {
			...defaultParams,
			...params,
		})
}
